import React, { useContext, useState } from 'react'
import moment from 'moment'
import { SectionHeader } from '../SectionKit'
import BigModal from '../../../../../components/Modals/BigModal'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
import AddNewInsurance from './AddNewInsurance'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import AddIcon from '@mui/icons-material/Add'
import AttachmentIcon from '@mui/icons-material/Attachment'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import AddNewMOT from './AddNewMOT'
import { VehicleContext } from '../../SingleVehicle'
import { Alert, Stack } from '@mui/material'
import S3DocumentUploadDisplay from '../../../../../components/images/S3DocumentUploadDisplay'
import MotModal from './MOTModal'
import { TenantSettingsContext } from '../../../../../App'

const MOTs = () => {
  const [openAddNew, setOpenAddNew] = useState(false)
  const { vehicle } = useContext(VehicleContext)
  const [selectedMOT, setSelectedMOT] = useState(null)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  const sortedMOTs = vehicle?.mots
    ? [...vehicle.mots].sort((a, b) => moment(b.date) - moment(a.date))
    : []

  return (
    <Stack spacing={1.5}>
      <SectionHeader
        title="MOTs"
        action={
          <Button
            variant="outlined"
            size="small"
            onClick={() => setOpenAddNew(true)}
            startIcon={<AddIcon />}
          >
            Add MOT
          </Button>
        }
      />
      {vehicle?.mots?.length >= 1 ? (
        <CustomDataGrid
          rows={sortedMOTs}
          columns={[
            {
              field: 'date',
              renderCell: ({ value }) =>
                moment(value).format('DD/MM/YYYY HH:mm'),
              minWidth: 200,
              headerName: 'Date',
            },
            {
              field: 'mileage',
              minWidth: 140,
              headerName: 'Mileage',
            },
            {
              field: 'pass',
              headerName: 'Pass',
              headerAlign: 'center',
              minWidth: 150,
              renderCell: ({ value }) => (
                <Box
                  width="100%"
                  height="100%"
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                >
                  {value ? (
                    <CheckCircleIcon color="success" />
                  ) : (
                    <CancelIcon color="error" />
                  )}
                </Box>
              ),
            },
            {
              field: 'testLocation',
              headerName: 'Test Location',
              minWidth: 150,
              flex: 1,
            },
            {
              field: 'testNumber',
              headerName: 'Test Number',
              minWidth: 150,
              flex: 1,
            },
            {
              field: 'cost',
              headerName: 'Cost',
              minWidth: 110,
              renderCell: ({ value }) =>
                value != null ? `${orgSettings?.currency ?? '£'}${Number(value).toFixed(2)}` : '—',
            },
            {
              field: 'documents',
              headerName: 'Documents',
              minWidth: 100,
              align: 'center',
              headerAlign: 'center',
              renderCell: ({ value }) => (
                <Box
                  alignItems="center"
                  justifyContent="center"
                  width="100%"
                  height="100%"
                  display="flex"
                >
                  {value.length >= 1 && <AttachmentIcon color="primary" />}
                </Box>
              ),
            },
          ]}
          getRowId={(params) => params._id}
          maxHeight={200}
          slots={{
            footer: () => null,
            toolbar: () => null,
          }}
          disableRowSelectionOnClick
          onRowClick={({ row }) => setSelectedMOT(row)}
        />
      ) : (
        <Alert severity="info">No MOT Records Yet</Alert>
      )}
      <BigModal open={openAddNew} onClose={() => setOpenAddNew(false)}>
        <AddNewMOT vehicle={vehicle} onClose={() => setOpenAddNew(false)} />
      </BigModal>
      <MotModal selectedMOT={selectedMOT} setSelectedMOT={setSelectedMOT} />
    </Stack>
  )
}

export default MOTs
